const apiURL = require("../config.js").apiURL;
const mockMapPresets = Object.create(null);
const f = {
  apiRequest(g, url, params = {}) {
    for (let param in params) {
      if (params[param] == null) {
        delete params[param];
      }
    }
    let k = new URLSearchParams(params).toString();
    return fetch("" + apiURL + url + (k ? "?" + k : ""))
      .then((m) => m.json())
      .catch((m) => g(m, null))
      .then((m) => g(null, m));
  },
  listMaps(g, h, j, k) {
    this.apiRequest(k, "/maps", {
      index: g,
      pos: h,
      accountId: j,
    });
  },
  listMods(g, h, j, k) {
    this.apiRequest(k, "/mods", {
      index: g,
      pos: h,
      accountId: j,
    });
  },
  searchMap(g, h) {
    this.apiRequest(h, "/search", {
      type: "map",
      val: g,
    });
  },
  listAssets(g, h, j, k, l) {
    this.apiRequest(l, "/assets", {
      index: g,
      cat: k,
      username: j,
    });
  },
  searchAsset(g, h, j) {
    this.apiRequest(j, "/assets", {
      index: 2,
      cat: h,
      val: g,
    });
  },
  setMapPresetMock(g, h) {
    mockMapPresets[g] = h;
  },
  clearMapPresetMock(g) {
    if (g == null) {
      for (const h in mockMapPresets) {
        delete mockMapPresets[h];
      }
      return;
    }
    delete mockMapPresets[g];
  },
  getMapPreset(g, h) {
    if (typeof h != "function") {
      return;
    }
    if (Object.prototype.hasOwnProperty.call(mockMapPresets, g)) {
      // Keep this async to match the network callback behavior.
      setTimeout(function () {
        h(g, mockMapPresets[g]);
      }, 0);
      return;
    }
    this.apiRequest(function (j, k) {
      h(g, (k || {}).da);
    }, "/config", {
      mn: g
    });
  },
  searchMod(g, h) {
    this.apiRequest(h, "/search", {
      type: "mod",
      val: g,
    });
  },
  listStreams(g, h) {
    this.apiRequest(h, "/streams", {
      index: g,
    });
  },
  getPrices(g) {
    this.apiRequest(g, "/prices");
  },
};
module.exports = f;
